"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var AppPaySystemWalletLockAmountsList = /** @class */ (function (_super) {
    __extends(AppPaySystemWalletLockAmountsList, _super);
    function AppPaySystemWalletLockAmountsList(props) {
        return _super.call(this, props) || this;
    }
    AppPaySystemWalletLockAmountsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.props.data.LoadData(_this.props.root.key);
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            searchTitleFilter: [],
            searchTitleValue: "",
            //
            searchDescriptionFilter: [],
            searchDescriptionValue: "",
            dtFormat: this.props.state.getDateTimeFormat(),
        }, function () {
            _this.props.data.LoadData(_this.props.root.key);
        });
        this.props.state.setExtBreadCrumbPath(["Замороженные суммы"]);
    };
    AppPaySystemWalletLockAmountsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    AppPaySystemWalletLockAmountsList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                nextProps.data.LoadData(nextProps.root.key);
            });
        }
    };
    AppPaySystemWalletLockAmountsList.prototype.getColumns = function () {
        var _this = this;
        return [{
                title: 'Кошелек',
                dataIndex: this.props.data.dk_wallet,
                key: this.props.data.dk_wallet,
                width: 200,
            }, {
                title: 'Пул кошельков',
                dataIndex: this.props.data.dk_pool_tag,
                key: this.props.data.dk_pool_tag,
                width: 200,
            }, {
                title: 'Сумма блокировки',
                dataIndex: this.props.data.dk_wait_amount,
                key: this.props.data.dk_wait_amount,
                align: "center",
                width: 200,
            }, {
                title: 'Дата добавления',
                dataIndex: this.props.data.dk_date_added,
                key: this.props.data.dk_date_added,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 100
            }];
    };
    AppPaySystemWalletLockAmountsList.prototype.bool2Int = function (val) {
        if (val) {
            return 1;
        }
        else {
            return 0;
        }
    };
    AppPaySystemWalletLockAmountsList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u0417\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 ",
                React.createElement("b", null,
                    "[",
                    record.wait_amount,
                    "]"),
                " \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    AppPaySystemWalletLockAmountsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.data.LoadData(_this.props.root.key, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, _PageSize);
                }
            });
        });
    };
    AppPaySystemWalletLockAmountsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.root.key);
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    AppPaySystemWalletLockAmountsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] ")));
                }, scroll: { x: true } })));
    };
    return AppPaySystemWalletLockAmountsList;
}(React.Component));
exports.default = AppPaySystemWalletLockAmountsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem_wallets/ui/component/AppPaySystemWalletLockAmountsList.tsx
// module id = 2566
// module chunks = 0